import config from "@/config.js";
import V from "@/main"; //- don't remove this line
// const CrossStorageClient = require("cross-storage").CrossStorageClient;
// const storage = new CrossStorageClient(
//   `${config.NEW_BASE_URL}cross-storage-hub`
// );

export default {
  namespaced: true,
  state: {
    appointment: {},
    ParentToken: '',
    ParentInfo: {},
    appointment_id: "",
    events: [],
    currentLocation: JSON.parse(localStorage.getItem("currentLocation")) || "",
    globalSearch: null,
    token: localStorage.getItem("token") || "",
    validRoles: [],
    userDetails: {
      full_name: "",
      mobile: "",
      declared_dead: {
        is_dead: false
      },
      qualifications: []
    },
    verifyUserModel: false,
    imagePreviewModal: false,
    loggedIn: localStorage.getItem("token") ? true : false,
    verifyModalDetails: {
      isStaff: false
    },
    imagePreviewModalDetails: {
      src: []
    },
    currentRole: localStorage.getItem("currentRole"),
    info: JSON.parse(localStorage.getItem("userInfo")) || {},
    myClinics: [],
    myFavs: "",
    notifications: [],
    total_reply_oc_count_patient: 0,
    total_reply_oc_count_doctor: 0,
    freeSubscriptionData: {},
    activePlanData: {},
    selectedCentreIdForSubscription: null,
    freeSubscriptionLoader: false,
    center_id: localStorage.getItem("center_id") || "",
    gst: !localStorage.getItem("gst") || localStorage.getItem("gst") !== 'undefined' ? JSON.parse(localStorage.getItem("gst")) : {},
  },
  getters: {
    getParentToken: (state) => {
      return state.ParentToken
    },
    getParentInfo: (state) => {
      return state.ParentInfo
    },
    GST: state => {
      return state.gst;
    },
    CURRENT_ROLE: state => {
      return state.currentRole;
    },
    NOTIFICATION_USER: state => {
      return state.notifications;
    },
    EVENTS: state => {
      return state.events;
    },
    getUserInfo: state => {
      return state.info;
    },
    getUserDetails: state => {
      return state.userDetails;
    },
    getCurrentLocation: state => {
      return state.currentLocation;
    },
    getToken: state => {
      return state.getToken;
    },
    getMyClinics: state => {
      return state.myClinics;
    },
    getFreeSubscriptionData: state => {
      return state.freeSubscriptionData
    },
    getFreeSubscriptionLoader: state => {
      return state.freeSubscriptionLoader
    },
    getActivePlanData: state => {
      return state.activePlanData
    },
    getSelectedCentreIdForSubscription: state => {
      return state.selectedCentreIdForSubscription
    },
    getMyFavs: state => {
      return state.myFavs;
    },
    Appointment: state => {
      return state.appointment;
    },
    Appointment_id: state => {
      return state.appointment_id;
    },
    getCenterId: state => {
      return state.center_id;
    }
  },
  mutations: {
    SET_GST: (state, gst) => {
      state.gst = gst;
      localStorage.setItem("gst", JSON.stringify(gst));
    },
    ADD_APPOINTMENT_ID: (state, event) => {
      state.appointment_id = event;
    },
    ADD_APPOINTMENT: (state, event) => {
      state.appointment = event;
    },
    ADD_EVENT: (state, event) => {
      state.events.push(event);
    },
    UPDATE_EVENT: (state, event) => {
      let index = state.events.findIndex(_event => _event.id == event.id);
      state.events[index].title = event.title;
      state.events[index].start = event.start;
      state.events[index].end = event.end;
    },
    logout: state => {
      state.userDetails = {};
      state.ParentInfo = {};
      state.token = "";
      state.ParentToken = "";
      state.loggedIn = false;
      state.info = {};
      let center = localStorage.getItem("logged_in_center");
      [
        "token",
        "ParentToken",
        "ParentInfo",
        "version_seen_by_role",
        "currentRole",
        "userInfo",
        "Clinic",
        "ParentToken",
        "ParentInfo",
        "dependentInfo"
      ].forEach(k => localStorage.removeItem(k));
      localStorage.setItem("logged_in_center", center);
      localStorage.setItem("selectedClinic", null);
    },
    setUserDetails: (state, userDetails) => {
      state.userDetails = userDetails;
      state.info = userDetails;
      if (userDetails.gst) {
        state.gst = userDetails.gst.filter(el => el.role === state.currentRole)[0];
        localStorage.setItem("gst", JSON.stringify(state.gst));
      }
    },
    setAssociationDetails: (state, payload) => {
      state.userDetails.association_memberships = payload;
    },
    setAssociationDetailsAllied: (state, payload) => {
      state.userDetails.allied.association_memberships = payload;
    },
    removeAssociationDetails: (state, payload) => {
      state.userDetails.association_memberships.splice(payload, 1);
    },
    removeAssociationDetailsAllied: (state, payload) => {
      state.userDetails.allied.association_memberships.splice(payload, 1);
    },
    setMiddleName: (state, middle_name) => {
      state.userDetails.middle_name = middle_name;
    },
    setEmail: (state, email) => {
      state.userDetails.email = email;
    },
    setEmailVerified: (state, payload) => {
      state.userDetails.is_email_verified = payload;
    },
    // setThirdLineAddress: (state, address_line_three) => {
    //   state.userDetails.address.current_address.address_line_three = address_line_three;
    // },
    homeCharges(state, homeCharges) {
      state.userDetails.home_visit.home_visit_charges = homeCharges;
    },
    onlineCharges(state, onlineCharges) {
      state.userDetails.online_consultation.base_charges = onlineCharges;
    },
    insuranceCompanyDetails(state, insuranceCompanyDetails) {
      state.userDetails.insurance_company_details = insuranceCompanyDetails;
    },
    govtPolicyDetails(state, govtPolicyDetails) {
      state.userDetails.govt_policy_panel_details = govtPolicyDetails;
    },
    insuranceCompaniesName(state, insuranceCompaniesName) {
      state.userDetails.insurance_companies = insuranceCompaniesName;
    },
    setToken(state, token) {
      localStorage.setItem("token", token);
      state.token = token;
    },
    setParentToken(state, ParentToken) {
      localStorage.setItem("ParentToken", ParentToken);
      state.ParentToken = ParentToken;
    },
    saveParentInfo(state, payload) {
      localStorage.setItem('ParentInfo', JSON.stringify(payload))
      state.ParentInfo = payload
    },
    setCurrentLocation(state, location) {
      state.currentLocation = location;
      localStorage.setItem("currentLocation", JSON.stringify(location));
    },
    setLoggedIn(state, content) {
      state.loggedIn = content;
    },
    setGlobalSearch(state, search) {
      state.globalSearch = search;
    },
    toggleVerifyUserModal(state, content) {
      state.verifyUserModel = content.toggle;
      if (content.toggle) state.verifyModalDetails = content;
    },
    toggleImagePreviewModal(state, content) {
      state.imagePreviewModal = content.toggle;
      if (content.toggle) state.imagePreviewModalDetails = content;
    },
    setCurrentRole(state, role) {
      state.currentRole = role;
      localStorage.setItem("currentRole", role);
    },
    saveUserDetails(state, payload) {
      localStorage.setItem("userInfo", JSON.stringify(payload));
      state.userDetails = payload;
      state.info = payload;
      if (payload.gst) {
        state.gst = payload.gst.filter(el => el.role === state.currentRole)[0];
        localStorage.setItem("gst", JSON.stringify(state.gst));
      }
    },
    setMyClinics(state, clinics) {
      state.myClinics = clinics;
    },
    setFreeSubscriptionData(state, payload) {
      state.freeSubscriptionData = payload
    },
    setFreeSubscriptionLoader(state, payload) {
      state.freeSubscriptionLoader = payload
    },
    setActivePlanData(state, payload) {
      state.activePlanData = payload
    },
    setSelectedCentreIdForSubscription(state, payload) {
      state.selectedCentreIdForSubscription = payload
    },
    // setMyFavs(state, favs) {
    //   let isadded = favs.includes("Added");
    //   let isRemoved = favs.includes("Removed");
    //   if (isadded === true) {
    //     state.myFavs += favs.replace("Added", "");
    //   } else if (isRemoved === true) {
    //     state.myFavs = state.myFavs.replace(favs.replace("Removed", ""), "");
    //   } else {
    //     state.myFavs = favs;
    //   }
    // },
    setPatientData(state, payload) {
      state.userDetails = payload;
      if (!payload.nominee) {
        state.userDetails.nominee = {
          first_name: "",
          last_name: "",
          relation: "",
          mobile: "",
          email: ""
        };
      }
      state.userDetails = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setTotalCountPatient(state, payload) {
      state.total_reply_oc_count_patient = payload;
    },
    setTotalCountDoctor(state, payload) {
      state.total_reply_oc_count_doctor = payload;
    },
    setCenterId(state, payload) {
      state.center_id = payload;
    },
  },
  actions: {
    setUserDetails(context, payload) {
      context.commit("setUserDetails", payload);
    },
    setMiddleName(context, payload) {
      context.commit("setMiddleName", payload);
    },
    setEmail(context, payload) {
      context.commit("setEmail", payload);
    },
    setEmailVerified(context, payload) {
      context.commit("setEmailVerified", payload);
    },
    setThirdLineAddress(context, payload) {
      context.commit("setThirdLineAddress", payload);
    },
    homeCharges(context, payload) {
      context.commit("homeCharges", payload);
    },
    onlineCharges(context, payload) {
      context.commit("onlineCharges", payload);
    },
    insuranceCompanyDetails(context, payload) {
      context.commit("insuranceCompanyDetails", payload);
    },
    govtPolicyDetails(context, payload) {
      context.commit("govtPolicyDetails", payload);
    },
    insuranceCompaniesName(context, payload) {
      context.commit("insuranceCompaniesName", payload);
    },
    setToken(context, payload) {
      context.commit("setToken", payload);
    },
    saveParentInfo: (context, payload) => {
      context.commit('saveParentInfo', payload)
    },
    setParentToken: (context, payload) => {
      context.commit('setParentToken', payload)
    },
    setLoggedIn(context, payload) {
      context.commit("setLoggedIn", payload);
    },
    logout(context, payload) {
      context.commit("logout", payload);
    },
    setCurrentLocation(context, payload) {
      context.commit("setCurrentLocation", payload);
    },
    toggleVerifyUserModal(context, payload) {
      context.commit("toggleVerifyUserModal", payload);
    },
    toggleImagePreviewModal(context, payload) {
      context.commit("toggleImagePreviewModal", payload);
    },
    setGlobalSearch(context, payload) {
      context.commit("setGlobalSearch", payload);
    },
    setCurrentRole(context, payload) {
      context.commit("setCurrentRole", payload);
    },
    saveUserDetails(context, payload) {
      context.commit("saveUserDetails", payload);
    },
    setMyClinics(context, self) {
      self.$http
        .get(config.NEW_BASE_URL + "api/v2/center/get-my-clinics")
        .then(function (response) {
          context.commit("setMyClinics", response.body.data);
        });
    },
    setFreeSubscriptionData(context, payload) {
      context.commit("setFreeSubscriptionData", payload);
    },
    setFreeSubscriptionLoader(context, payload) {
      context.commit("setFreeSubscriptionLoader", payload);
    },
    setActivePlanData(context, payload) {
      context.commit("setActivePlanData", payload);
    },
    setSelectedCentreIdForSubscription(context, payload) {
      context.commit("setSelectedCentreIdForSubscription", payload);
    },
    setLoggedInCenter(context, center) {
      localStorage.setItem("logged_in_center", JSON.stringify(center));
    },
    // setMyFavs(context, self) {
    //   if (typeof self == "string") {
    //     context.commit("setMyFavs", self);
    //   } else {
    //     self.$http
    //       .post(config.NEW_BASE_URL + "api/v2/favourites/list", {
    //         compressed: true
    //       })
    //       .then(function(response) {
    //         context.commit("setMyFavs", response.body.data.favs);
    //       });
    //   }
    // },
    getUserData(context) {
      return V.$http
        .get(`${config.NEW_BASE_URL}api/v2/profile`, {
          headers: {
            Authorization: `JWT ${localStorage.token}`
          },
          params: {
            role: localStorage.getItem("currentRole")
          }
        })
        .then(response => {
          console.log(response.body.data);
          context.commit("setUserDetails", response.body.data);
          // storage
          // .onConnect()
          // .then(() => {
          //   return storage.set("userInfo", JSON.stringify(response.body.data));
          // })
        })
        .catch(err => console.log(err));
    },
    setCenterId(context, centerId) {
      context.commit("setCenterId", centerId);
    },
    setGst(context, payload) {
      context.commit('SET_GST', payload)
    },
  }
};
